// Copyright (c) 2016 Deere & Company

import actions from '../../action-list';

export const resetProductDetails = () => ({
    type: actions.RESET_CLAIM_PIP_PRODUCT_DETAILS
});



// WEBPACK FOOTER //
// ./src/claim/pip/action-creators/reset-product-details.js